import React, { useContext, useEffect } from 'react';
import { UserContext } from '../UserContext';
import { Outlet, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import styles from '../components/css/global.module.css';
import contentStyles from '../components/css/main-content.module.css';

const MainLayout = () => {
    const navigate = useNavigate();
    const { user, setUser } = useContext(UserContext);

    useEffect(() => {
        const userData = localStorage.getItem('userData');
        if (userData) {
            setUser(JSON.parse(userData));
        }
    }, [setUser]);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('userData');
        navigate('/login');
    };

    return (
        <div className={styles.mainLayoutContainer}>
            {/* Sidebar */}
            <Sidebar handleLogout={handleLogout} />

            {/* Main Content */}
            <div className={contentStyles.mainContent}>
                <Outlet />
            </div>
        </div>
    );
};

export default MainLayout;
